import React from 'react';
import { withRouter } from 'react-router-dom';
import { Level } from 'rbx';
import styled from 'styled-components';
import Search from './Search';
import { SubHeading, Heading } from '../../../components/elements';

const Wrapper = styled.div`
  padding: 1rem 1rem;
  border-bottom: 1px solid #f6f6f6;
`;

const Header = ({ isActiveTab }) => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Heading>Event Order Activity</Heading>
      </Level.Item>
    </Level>
    <Search />
    {isActiveTab === 'ActivitySummary' && (
      <>
        <SubHeading className="is-size-2 has-text-weight-semibold">
          Stokehouse St Kilda
        </SubHeading>
        <SubHeading className="is-size-3">
          St Kilda, 3182 | Australia
        </SubHeading>
      </>
    )}
    {isActiveTab === 'ActivityDetail' && (
      <>
        <SubHeading className="is-size-2  has-text-weight-semibold">
          Olive Backyard (Public event)
        </SubHeading>
        <SubHeading className="is-size-3">Sunda Dining | Victoria</SubHeading>
        <SubHeading className="is-size-3">
          56 Saint Kilda | St Kilda | 3182 | Australia
        </SubHeading>
        <SubHeading className="is-size-4  has-text-weight-semibold">
          Wednesday, June 3, 2020 8:13 PM
        </SubHeading>
      </>
    )}
  </Wrapper>
);

export default withRouter(Header);
